import Index from '@app/views/dictionaries';
import Mkb10Page from '@app/views/dictionaries/pages/Mkb10';
import GrlsPage from '@app/views/dictionaries/pages/Grls';

export default {
  path: '/dictionaries',
  component: Index,
  children: [
    {
      path: '',
      redirect: {
        name: 'dictionary.mkb10'
      },
      name: 'dictionaries.index'
    },
    {
      path: 'mkb10',
      name: 'dictionary.mkb10',
      component: Mkb10Page
    },
    {
      path: 'grls',
      name: 'dictionary.grls',
      component: GrlsPage
    }
  ]
};
